import React from "react";
var __jsx = React.createElement;
import { useState, useRef } from "react";
import { BREAKPOINTS } from "@lib/constants";
import { LabeledIconButton } from "@modules/shared/components/buttons";
import Icons from "@modules/icons";
import { useTranslations } from "next-intl";
import PassengerQuantitySelector from "./components/passengers-quantity-selector";
import { useMediaQuery } from "react-responsive";
import APP_CONFIGURATION from "@lib/app.config";
import PassengerDetailBase from "@modules/flights/layout/components/search-header/components/passenger-detail-base";
import UniqueSelectionInput from "@modules/shared/components/unique-selection-input";
import CabinDetailBase from "@modules/flights/layout/components/search-header/components/cabin-detail-base";
import MuscleDropdown from "@modules/shared/components/dropdown";
import useAfterInitEffect from "@lib/hooks/use-after-initialization-effect";
import { useMobileFilters } from "@lib/context/mobile/filters-context";
import useCssModules from "@lib/hooks/use-css-modules";
const PassengersAndCabinFlyOver = _ref => {
  let {
    onClick
  } = _ref;
  const t = useTranslations("Flights");
  const {
    0: isOpen,
    1: setIsOpen
  } = useState(false);
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  const {
    flightFilters
  } = useMobileFilters();
  const passengerQty = flightFilters.passengersDetails.adults + flightFilters.passengersDetails.children + flightFilters.passengersDetails.infants + flightFilters.passengersDetails.infants_with_seat;
  const buttonRef = useRef(null);
  const {
    cssModules
  } = useCssModules();
  const {
    passengerSelectionTitle
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.views.desktop.PassengerSelection) || {};
  const {
    selectors_text
  } = APP_CONFIGURATION.colors.home;
  useAfterInitEffect(() => {
    if (!isOpen) {
      if (flightFilters.hasPassengerError) {
        setIsOpen(true);
      }
    }
  }, [isOpen, flightFilters.hasPassengerError]);
  const handleSelection = () => {
    !isMobile ? setIsOpen(prev => !prev) : setIsOpen(false);
    onClick === null || onClick === void 0 || onClick();
  };
  const handleCabinSelection = option => {
    flightFilters.handleSetCabin(option.key);
  };
  return __jsx("div", {
    className: "flex flex-col w-fit"
  }, __jsx(LabeledIconButton, {
    ref: buttonRef,
    label: __jsx("div", {
      className: "flex gap-4"
    }, __jsx(PassengerDetailBase, {
      quantity: passengerQty,
      color: APP_CONFIGURATION.colors.home.selectors,
      className: selectors_text
    }), __jsx(CabinDetailBase, {
      cabin: flightFilters.selectedCabin,
      color: APP_CONFIGURATION.colors.home.selectors,
      className: selectors_text
    })),
    icon: __jsx(Icons.chevronDown, {
      size: 14,
      strokeWidth: 1
    }),
    iconPosition: "end",
    labelClassName: "text-secondary-main tx-pmd-regular",
    labelColor: APP_CONFIGURATION.colors.home.selectors,
    buttonClassName: "flex items-center justify-center mt-[5px]",
    onClick: handleSelection,
    dataTestId: "flight-search-passengers-and-cabin-fly-over"
  }), !isMobile && __jsx(MuscleDropdown, {
    buttonRef: buttonRef,
    isOpenState: isOpen,
    setIsOpenState: setIsOpen
  }, __jsx(PassengerQuantitySelector, {
    onClose: () => setIsOpen(false)
  }, __jsx("div", {
    className: "global-x-division-line"
  }), __jsx("p", {
    className: passengerSelectionTitle
  }, t("CABIN")), __jsx(UniqueSelectionInput, {
    dataTestId: "flight-search-passengers-and-cabin-fly-over-cabin",
    options: flightFilters.cabinOptions,
    radioSize: "xl",
    onSelectOption: handleCabinSelection,
    value: flightFilters.cabinOptions.find(option => option.key === flightFilters.selectedCabin)
  }))));
};
export default PassengersAndCabinFlyOver;